/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsCustomerConfig} from '../api'

 export const useQueryGetSavingsCustomerConfig = createReactQueryHook('getSavingsCustomerConfig', getSavingsCustomerConfig)
